const ITEMS = [
  "100 % mobil vor Ort",
  "Tiefenreinigung",
  "Lederpflege",
  "Polsterreinigung",
  "Geruchsentfernung",
  "Faire Preise",
  "Rotenburg (Wümme)",
];

function Group({ hidden }) {
  return (
    <div className="flex items-center shrink-0" aria-hidden={hidden || undefined}>
      {ITEMS.map((item) => (
        <span key={item} className="flex items-center whitespace-nowrap">
          <span className="px-6 sm:px-8 font-mono text-xs sm:text-sm uppercase tracking-[0.2em] text-zinc-400">
            {item}
          </span>
          <span className="font-mono text-blue-400 text-xs">{"//"}</span>
        </span>
      ))}
    </div>
  );
}

export default function Marquee() {
  return (
    <div data-testid="marquee-ribbon" className="marquee relative overflow-hidden border-y border-white/5 bg-[#0C0C0E] py-4">
      <div className="marquee-track">
        <Group />
        <Group hidden />
      </div>
    </div>
  );
}
